import { render, staticRenderFns } from "./orderReceipt.vue?vue&type=template&id=4133a766&scoped=true&"
import script from "./orderReceipt.vue?vue&type=script&lang=js&"
export * from "./orderReceipt.vue?vue&type=script&lang=js&"
import style0 from "./orderReceipt.vue?vue&type=style&index=0&id=4133a766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4133a766",
  null
  
)

export default component.exports